module.exports = __webpack_public_path__ + "img/cpa.d18ddce.png";